import { createActions } from 'redux-actions';
import { call, race, take } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'react-router-redux';
import {
  apiActions as commonApiActions,
  apiResourceActionCreator
} from '../../common';
import { API_ENDPOINT } from './endpoints';
import { createPollingWorker } from './pollingUtils';

const actions = createActions({
  TASK: {
    GET_BUSINESS_EMAIL_JOB_STATUSES: (businessId) => ({ businessId }),
    API: {
      GET_BUSINESS_EMAIL_JOB_STATUSES: apiResourceActionCreator(
        'businessEmailJobStatuses'
      )
    }
  }
});

const apiAction = (authToken, businessId) =>
  commonApiActions.authenticated.get(
    `${API_ENDPOINT}/business-tasks/${businessId}/email-job-statuses`,
    authToken,
    actions.task.api.getBusinessEmailJobStatuses
  );

/**
 * Periodically dispatches requests to fetch background email job statuses
 * and continues execution until all background jobs reach a terminal state.
 */
const pollBusinessEmailJobStatusesWorker = createPollingWorker({
  apiAction,
  apiTarget: actions.task.api.getBusinessEmailJobStatuses,
  loggerName: 'Job Queue Poller',
  shouldStopPolling: (payload) => {
    const jobs = payload.businessEmailJobStatuses || [];
    return !jobs.some(
      (job) => job.status === 'PENDING' || job.status === 'PROCESSING'
    );
  }
});

function* getBusinessEmailJobStatusesSaga(action) {
  const { businessId } = action.payload;
  yield race({
    poll: call(pollBusinessEmailJobStatusesWorker, businessId),
    cancel: take(LOCATION_CHANGE)
  });
}

/**
 * Redux configuration mapping action actions, polling sagas, and slice
 * reducers for collecting live automated notification job statuses.
 */
const configuration = {
  name: 'getBusinessEmailJobStatuses',
  action: actions,
  sagas: getBusinessEmailJobStatusesSaga,
  reducers: {
    request: (state) => ({ ...state }),
    success: (state, action) => ({
      ...state,
      businessEmailJobStatuses: action.payload.businessEmailJobStatuses || []
    }),
    failed: (state) => ({ ...state })
  }
};

export default configuration;



// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/getBusinessEmailJobStatuses.js